// Bestillerens fakturaopplysninger (users/{uid}.billingProfile): mottaker på fakturaene.
// E-posten hentes fra kontoen. Organisasjonsnummer er valgfritt (privatkunder).
import { cleanDigits, isValidOrgNumber } from './invoiceProfile';

// Samme grenser som Firestore-reglene.
export const BILLING_PROFILE_LIMITS = { name: 120, street: 120, city: 80 };

export const EMPTY_BILLING_PROFILE = {
  name: '',
  orgNumber: '',
  invoiceAddress: { street: '', postalCode: '', city: '' },
};

// Det som lagres i Firestore: kun siffer i organisasjonsnummeret og trimmet tekst.
export function normalizeBillingProfile(profile) {
  const p = profile ?? {};
  const a = p.invoiceAddress ?? {};
  return {
    name: String(p.name ?? '').trim(),
    orgNumber: cleanDigits(p.orgNumber),
    invoiceAddress: {
      street: String(a.street ?? '').trim(),
      postalCode: String(a.postalCode ?? '').trim(),
      city: String(a.city ?? '').trim(),
    },
  };
}

// Feilmeldinger per felt. Tomt objekt betyr at profilen er komplett.
export function validateBillingProfile(profile) {
  const p = normalizeBillingProfile(profile);
  const errors = {};
  const tooLong = (max) => `Maks ${max} tegn`;
  if (!p.name) errors.name = 'Skriv inn navn eller firmanavn';
  else if (p.name.length > BILLING_PROFILE_LIMITS.name) errors.name = tooLong(BILLING_PROFILE_LIMITS.name);
  if (p.orgNumber !== '' && !isValidOrgNumber(p.orgNumber)) errors.orgNumber = 'Ugyldig organisasjonsnummer (9 siffer)';
  if (!p.invoiceAddress.street) errors.street = 'Skriv inn gateadresse';
  else if (p.invoiceAddress.street.length > BILLING_PROFILE_LIMITS.street) errors.street = tooLong(BILLING_PROFILE_LIMITS.street);
  if (!/^\d{4}$/.test(p.invoiceAddress.postalCode)) errors.postalCode = 'Postnummer må være fire siffer';
  if (!p.invoiceAddress.city) errors.city = 'Skriv inn poststed';
  else if (p.invoiceAddress.city.length > BILLING_PROFILE_LIMITS.city) errors.city = tooLong(BILLING_PROFILE_LIMITS.city);
  return errors;
}

export function isBillingProfileComplete(profile) {
  return Object.keys(validateBillingProfile(profile)).length === 0;
}
